import { useEffect, useRef } from "react";
import {MapWrapper} from "./map-wrapper";

export const useMap = (potreeViewer, pointCloudProjection, guiLoaded) => {
    const mapRef = useRef();
    useEffect(() => {
        if(!pointCloudProjection || !potreeViewer || !guiLoaded) return;
        let mapProjection = window.proj4.defs("WGS84");

        window.toMap = window.proj4(pointCloudProjection, mapProjection);
        window.toScene = window.proj4(mapProjection, pointCloudProjection);

        let mapWrapper = new MapWrapper(potreeViewer);
        potreeViewer.scene.setMap(mapWrapper);
        mapRef.current = mapWrapper;
    }, [pointCloudProjection, potreeViewer, guiLoaded]);

    useEffect(() => {
        return () => {
            mapRef.current?.dispose();
        };
    }, [potreeViewer]);
};
